module.exports = __webpack_public_path__ + "img/ennetix-xtend-packages-table.36985171.png";